/** EvolveRPG — English overrides for the Play / VTT feature. Fast-play, momentum-driven voice. */
export const playEvoEn = {
  // CampaignList
  'play.campaigns.loading': 'Loading your sessions…',

  // CampaignPage — VTT prototype
  'play.vtt.iframeTitle': 'EvolveRPG VTT — campaign {campaignId}',
  'play.vtt.veilHeadline': 'Zero downtime between table and tale here.',

  // CampaignPage — encyclopedia sidebar
  'play.codex.searching': 'Scanning…',
  'play.codex.hint': 'Type at least two letters to search the codex without leaving your table.',

  // CharacterSheet
  'play.sheet.savedToCodex': 'Saved to your codex.',
  'play.sheet.unclaimedHero': 'Unclaimed character',
  'play.sheet.backstoryPlaceholder': 'Give them a quick backstory — keep it fast.',
  'play.sheet.canonCandidateHint': 'Opt this character in for consideration as part of the living EvolveRPG canon.',

  // CreateGameModal
  'play.create.errorCreate': 'Something glitched — your table could not be created. Try again shortly.',
  'play.create.modalTitle': 'Launch a Table',
  'play.create.successCopy': 'Your table is live. Share this invite link to pull in your players.',
  'play.create.tableNamePlaceholder': 'e.g. Boss Fight Tonight',
  'play.create.systemDefault': 'EvolveRPG Core (default)',

  // JoinPage
  'play.join.defaultTableTitle': 'An EvolveRPG table',

  // PlayLobbyPage
  'play.lobby.seoDescription':
    'Find a table, jump in fast, and evolve your character in real time at the EvolveRPG virtual tabletop.',
  'play.lobby.subtitle':
    'Session zero to boss fight tonight. Pull up a chair — every roll moves the story, and your character, forward, fast.',

  // SessionListLive
  'play.live.empty': 'No tables are live right now. Kick one off — it takes under a minute.',

  // TableList — empty board
  'play.tables.emptyBody':
    'Nobody is at the table yet. Be the first to pull up a chair — try the guest table instantly, no account needed.',
}
